import { FC } from "react";
import classNames from "classnames";
import { Button } from "src/UI";
import { ReactComponent as ChevronIcon } from 'src/Themes/assets/chevron-left.svg';
import st from "./SubMenuFooter.module.scss";

interface ISubMenuFooterProps {
	id: string;
	expanded?: boolean;
	disabled?: boolean;
	toggleExpand: () => void;
	renderFooter?: FC<ISubMenuFooterProps>;
};

const SubMenuFooter: FC<ISubMenuFooterProps> = ( props ) => {

	const { id, expanded = true, disabled = false, toggleExpand, renderFooter } = props;
	const btnExHint = expanded ? "Свернуть " : "Развернуть ";

	return (
		<div id={ id + "_footer" } className={st.footer}>
			<div className={st.footer__userPart}>
				{ renderFooter && renderFooter( props ) }
			</div>
			<Button 
				id={ id + "_expandBtn" }
				className={classNames(st.footer__expandBtn, { [st.notExpanded]: !expanded } )} 
				outline 
				disable={disabled} 
				onClick={toggleExpand}
				data-tooltip-id="rdc_tooltip" 
				data-tooltip-content={btnExHint}
			>
				<ChevronIcon />
			</Button>
		</div>
	);
};

export default SubMenuFooter;
